import React, { ReactElement } from "react";
import { ToelichtingHypotheekvormHoofdstuk } from "../../../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../../../components/Chapter";
import Heading from "../../../../components/Heading";
import { Motivering } from "../../../../components/Motivering";
import { HypotheekAflossingTable } from "./hypotheek-aflossing-tabel";

export const ToelichtingAdviesAflossingsvormChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingHypotheekvormHoofdstuk;
}): ReactElement => {
  // Transform the hypotheekaflossing object to array format
  const hypotheekvormDataArray = hoofdstuk.hypotheekaflossing
    ? Object.entries(hoofdstuk.hypotheekaflossing).map(([jaar, data]) => ({
        ...data,
        jaar: parseInt(jaar, 10),
      }))
    : [];

  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text="Aflossingsvorm" level={3} />
        <Motivering
          wens={hoofdstuk.wens}
          advies={hoofdstuk?.advies}
          keuze={hoofdstuk?.keuze}
        />
        <HypotheekAflossingTable hypotheekvormData={hypotheekvormDataArray} />
      </div>
    </Chapter>
  );
};
